/**
 * Escape any old text so that all of the characters are used a literals.
 */
export function escapeRegex(text: string) {
	return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}